export const GOOGLE_PARTNER_ID = '463';
export const META_PARTNER_ID = '641';
export const IBM_PARTNER_ID = '348';
